module.exports = __webpack_public_path__ + "media/images/faces/male/7-6d66f6a7e9e4b7f134c9a4d01860c091.jpg";